import { render, staticRenderFns } from "./WalletOpenButton.vue?vue&type=template&id=116c667a&scoped=true&"
import script from "./WalletOpenButton.vue?vue&type=script&lang=js&"
export * from "./WalletOpenButton.vue?vue&type=script&lang=js&"
import style0 from "./WalletOpenButton.vue?vue&type=style&index=0&id=116c667a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116c667a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VSkeletonLoader,VSpacer})
